<div class="hero-bg hero-bg-btw-academy">
  <app-navbar/>
  <div class="d-flex flex-column justify-content-center hero-header">
    <div class="app-container">
      <h1 class="new-line">{{ 'btwAcademy.description' | translate }}</h1>
    </div>
  </div>
</div>
